import React from "react";
import { connect } from "react-redux";
import { reduxForm } from "redux-form";
import { ff, form } from "@mc/mc-legacy";
const { Form, FormBody, FormActions } = form;

const validate = (formData) => {
  if (Object.keys(formData).length != 0) {
    const errors = {};

    if (!formData.pracovnik.uplneJmeno) {
      if (!errors.pracovnik) {
        errors.pracovnik = {};
      }

      errors.pracovnik.uplneJmeno = "Povinný parametr";
    }

    if (!formData.pracovnik.loginName) {
      if (!errors.pracovnik) {
        errors.pracovnik = {};
      }

      errors.pracovnik.loginName = "Povinný parametr";
    }

    return errors;
  }
};

class SignerForm extends React.Component {
  static formName = "SignerForm";

  render() {
    const { onClose, submitting, handleSubmit } = this.props;
    return (
      <Form onSubmit={handleSubmit}>
        <FormBody>
          <ff.String required label="Zobrazované jméno" name="pracovnik.uplneJmeno" disabled={submitting} />
          <ff.String required label="Uživatelské jméno" name="pracovnik.loginName" disabled={submitting} />
          <ff.String label="E-Mail" name="pracovnik.email" disabled={submitting} />
          <ff.String label="HSM Login" name="hsmId" disabled={submitting} />
          <ff.Checkbox
            label={false}
            checkboxLabel="Zakládání požadavků"
            name="canCreateRequest"
            title="...povoleno"
            disabled={submitting}
          />
          <ff.Checkbox
            label={false}
            checkboxLabel="Zablokovat účet"
            name="blocked"
            title="...povoleno"
            disabled={submitting}
          />
        </FormBody>
        <FormActions onClose={onClose} storeButton cancelButton disabled={submitting} />
      </Form>
    );
  }
}

export default connect()(
  reduxForm({
    form: SignerForm.formName,
    validate: validate,
  })(SignerForm)
);
